// Clipboard writes can be refused (tab not focused, permissions, insecure
// origin). Resolve to true/false instead of throwing so every copy button can
// tell the manager what happened.
export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
